import type { FaireProductEntity } from "../../entity_types/product";

export const p_edyfrgqp29: FaireProductEntity = {
  token: "p_edyfrgqp29",
  type: "product",
  name: "Thermal Teapot – Sakura and Cat Design",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/c5dbe41f9751d9ac5a62729bf07318988effc9409f9372d72748e2d23ca1c119.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40adc4d9102c3e736d0f523c9d7af155a7ff426ad7480c1f1ea7bf88bf0308e3.jpeg",
    "https://cdn.faire.com/fastly/742ab206ae8fdc9986ec5394bdfff4eb3ac096ef1cfd605daddb2a40990f39d6.jpeg"
  ],
  priceDollars: 14,
  description: "Keep tea warm at the table with this thermal teapot in the Sakura and Cat design. Insulated to hold the temperature of tea and hot water, it suits cafés, tea shops and Japanese restaurants, and makes a cheerful gift for tea lovers.\n\nFeatures\n\n * Thermal teapot: insulated to keep tea and hot water warm \n * Coordinated collection: pair with Urban Tokyo tea cups and thermal flasks \nSpecifications\n\n * Design: Sakura and Cat \n * Inner pack: 1 \n * Case pack: 24 \n * Origin: China ",
  tags: [],
  msrpDollars: 31.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:53.304Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
